var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('px-oferta-foto',{attrs:{"height":"500","width":"500","align":"center","foto":_vm.oferta.produto.foto}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }